import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import {IStateRes,IState } from './index.type';

const useFetchPatient = () => {
  const [states, setStates] = React.useState<IState[]>();
  const { loading:stateLoading, makeApiCall } = useApi({
    // url: `/RTM/getAllStates`,
    url: `/rtm/general/states`,
    method: 'GET',
  });

  const getState = async () => {
    const { response, error } = await makeApiCall<undefined, IStateRes>();
    if (response?.status) {
        setStates(response?.states);
    }

    if (!response?.status) {
        setStates(undefined);
    }

    if (error) toast.error(error.msg || 'Something went wrong while fetching state. Please try again later');
  };

  return {
    states,
    getState ,
    stateLoading,
  };
};

export default useFetchPatient;
